if (!window.DealWithCard) {
  window.DealWithCard = class DealWithCard {
    constructor(
      optionsWithValues,
      variants,
      media,
      isShowSaleTag,
      colorList,
      mainImgIdx,
      hoverImgIdx,
      cardId,
      format,
      activeColorIndex,
      saleVariantId
    ) {
      this.optionsWithValues = optionsWithValues;
      this.variants = variants;
      this.media = media;
      this.isShowSaleTag = isShowSaleTag;
      this.colorList = colorList;
      this.mainImgIdx = mainImgIdx;
      this.hoverImgIdx = hoverImgIdx;
      this.format = format;
      this.activeColorIndex = activeColorIndex;
      this.saleVariantId = saleVariantId;
      this.wrapper = document.querySelector(`#vernal-card-${cardId}`);
      this.el = this.wrapper.querySelector(`merchandise-card`);
      this.tag = this.wrapper.querySelector(`.card_saleTip`);
      this.init();
    }

    static run(...args) {
      return new DealWithCard(...args);
    }

    init() {
      this.changeCardDisplayByColor(this.colorList[this.activeColorIndex].title);
      this.el.addEventListener('changeColorRadio', ({ detail }) => this.changeCardDisplayByColor(detail));
      this.renderCardTagInfo();
      this.render();
    }

    renderCardTagInfo() {
      if (this.isShowSaleTag?.is_promoting) {
        this.computeSaleDiscount();
      }
    }

    changeCardDisplayByColor(colorName) {
      const [mainImageSrc, hoverImgSrc] = this.getCurrentVariantImage(colorName, this.mainImgIdx, this.hoverImgIdx);
      this.el.displayImgSrc = mainImageSrc;
      this.el.hoverImgSrc = hoverImgSrc;

      if (this.wrapper.querySelector('.price-2lines-compare-at-price')) {
        this.wrapper.querySelector('.price-2lines-compare-at-price').innerText = DealWithCard.formatMoney(
          this.currentVariant.compare_at_price,
          this.format
        );
      }
      if (this.wrapper.querySelector('.price-2lines-price-price')) {
        this.wrapper.querySelector('.price-2lines-price-price').innerText = DealWithCard.formatMoney(
          this.currentVariant.price,
          this.format
        );
      }
    }

    computeSaleDiscount() {
      if (this.variants.length <= 0 || this.variants.some((item) => !item.compare_at_price)) return;
      const largestDiscount = this.variants.reduce((preVal, currentVariant) => {
        const discount = this.isShowSaleTag.is_show_discount
          ? (currentVariant.compare_at_price - currentVariant.price) / currentVariant.compare_at_price
          : currentVariant.compare_at_price - currentVariant.price;
        if (discount > preVal) {
          return discount;
        } else {
          return preVal;
        }
      }, 0);

      this.tag.innerText = this.isShowSaleTag.is_show_discount
        ? `-${Math.ceil(largestDiscount * 100)}%`
        : `-${(largestDiscount / 100).toFixed(2)}`;
    }

    render() {
      this.el.colorList = this.colorList;
      this.el.loading = false;
    }

    getCurrentVariant(colorName) {
      if (this.saleVariantId) {
        return this.currentVariant ? this.currentVariant : this.variants.find((variant) => variant.id === this.saleVariantId);
      } else {
        return this.variants.find((variant) => variant.option1 === colorName);
      }
    }

    getCurrentVariantImage(colorName, mainImgIdx, hoverImgIdx) {
      // this.currentVariant = this.variants.find((variant) => variant.option1 === colorName);
      this.currentVariant = this.getCurrentVariant(colorName);
      // 从当前variant的主图到下一个variant的主图间的图片都是属于该variant的图片组
      const currentMasterImgId = this.currentVariant.featured_media.id;
      const variantMasterImgIdArr = [...new Set(this.variants.map((item) => item.featured_media.id))];
      const currentVariantImgArr = [];
      let start = false;
      for (let img of this.media) {
        if (!start && img.id == currentMasterImgId) {
          start = true;
          currentVariantImgArr.push(img);
        } else if (start) {
          if (variantMasterImgIdArr.includes(img.id)) break;
          currentVariantImgArr.push(img);
        }
      }
      return [`https:${currentVariantImgArr[mainImgIdx].src}`, `https:${currentVariantImgArr[hoverImgIdx].src}`];
    }

    static buildColorList(optionsWithValues, size = 12) {
      const colorOption = optionsWithValues[0].values;
      const colorList = colorOption?.map((color) => {
        const colorImage = `${'{{ shop.url }}'}/cdn/shop/files/${color.replace(/[A-Z]/g, (match) => {
          return match.toLowerCase();
        })}_${size}x${size}.png`;
        return {
          title: color,
          overLayImage: colorImage,
        };
      });
      return colorList;
    }

    static formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '${{amount}}';

      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
  };
}
